import {
  EngagementSettingDaysEnum,
  EngagementSettingFrequencyEnum,
  EngagementSettingQuestionTypeEnum,
} from 'generated/resources/graphql'

type Pulse = 'superNegative' | 'negative' | 'neutral' | 'positive' | 'superPositive'

const VALUE_PULSE: Record<number, Pulse> = {
  1: 'superNegative',
  2: 'negative',
  3: 'neutral',
  4: 'positive',
  5: 'superPositive',
}

export const valueToPulse = (value: number) => {
  if (!value) return

  return VALUE_PULSE[value]
}

export type PulseConfiguration = {
  frequency: EngagementSettingFrequencyEnum
  days: EngagementSettingDaysEnum[]
  questionType: EngagementSettingQuestionTypeEnum
  question: string
}
